import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react"; // Make sure you have lucide-react installed

const testimonials = [
  {
    quote: "MasterPlan has been successful in creating an impact on the Youth of Arabia through their energetic and soulful performances",
    author: "Bishop Paul Hinder OFM Cap"
  },
  {
    quote: "Super-talented bunch with a heart for God",
    author: "Alphons Joseph, Music Director"
  },
  {
    quote: "Best Christian act in the Region",
    author: "Eloy Isaacs, Guitarist - 13AD"
  },
  {
    quote: "Boy, these guys are tight",
    author: "Fr. Stan Fortuna"
  }
];

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative py-24 lg:py-32 bg-black overflow-hidden">
      {/* Background Effects (Matching Contact Section) */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-600 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-7xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-purple-400 mb-6 uppercase">
            What People Say
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-green-400 to-purple-400 mx-auto" />
        </motion.div>

        {/* Testimonial Card */}
        <div className="max-w-4xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-gray-900/50 to-purple-900/30 backdrop-blur-xl border border-purple-500/20 rounded-3xl p-8 md:p-12 relative overflow-hidden min-h-[400px] flex flex-col justify-center items-center text-center"
          >
            {/* Giant Quote Icon Background */}
            <Quote className="absolute top-8 left-8 w-24 h-24 text-purple-500/10 rotate-180" />
            <Quote className="absolute bottom-8 right-8 w-24 h-24 text-purple-500/10" />

            {/* Content with Animation */}
            <div className="relative z-10">
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentTestimonial}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.5 }}
                >
                  <p className="text-2xl md:text-4xl font-light italic mb-8 leading-relaxed text-gray-200">
                    "{testimonials[currentTestimonial].quote}"
                  </p>
                  <p className="text-xl text-green-400 font-bold tracking-wide uppercase">
                    — {testimonials[currentTestimonial].author}
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Dots Navigation */}
            <div className="flex justify-center gap-3 mt-12 relative z-20">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`h-2 rounded-full transition-all duration-500 ${
                    index === currentTestimonial 
                      ? "bg-gradient-to-r from-green-400 to-purple-400 w-12" 
                      : "bg-gray-700 w-2 hover:bg-gray-500"
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;